import React, { useState } from 'react';
import { OverlayContainer } from '@react-aria/overlays';

import {
  FilterModalHeader,
  FilterModalOptions,
  FilterSearchBar,
} from 'src/pages/CatalogPage/components/FilterMenu/CaliberFilterModal/FilterModal.style';
import { Modal, ModalContentArea } from '@riac/design-system';
import { InvertedRadioOption } from 'src/components/Input/RadioInput/InvertedRadioInput';
import { Input } from '@riac/design-system';
import { BoxButton } from '@riac/design-system';

import { IMapping } from 'src/pages/CatalogPage/Catalog.i';
import { TFacet } from 'src/pages/CatalogPage/CatalogPage.i';


interface IManuModal {
  changeFilter(slug: string, field: string): void;
  close(): void;
  manuMappings: IMapping[];
  manu: string;
  facets: TFacet;
}

export const ManuFilterModal = (props: IManuModal) => {
  const [searchInput, setSearchInput] = useState('');
  const [sortAlpha, setSortAlpha] = useState(true);

  function handleInput(val) {
    setSearchInput(val);
  }

  function closeModal() {
    props.close();
  }

  function clearSearch() {
    setSearchInput('');
  }

  if(props.manuMappings.length === 0) {
    return null;
  }
  const manuFilteredList = Object.keys(props.facets).filter((manu) =>
    manu.toLowerCase().trim().includes(searchInput.toLowerCase().trim())
  );

  return (
    <OverlayContainer>
      <Modal
        isOpen
        onClose={closeModal}
        showCloseButton
        isDismissable
        title='Filter By Manufacturer'
        fullHeight
      >
        <ModalContentArea>
          <FilterModalHeader>
            <div>
              <InvertedRadioOption
                value='alpha'
                onChange={() => setSortAlpha(true)}
                name='sort_manu'
                checked={sortAlpha}
              >
                Sort alphanumerically
              </InvertedRadioOption>
              <InvertedRadioOption
                value='num'
                onChange={() => setSortAlpha(false)}
                name='sort_manu'
                checked={!sortAlpha}
              >
                Sort by most popular
              </InvertedRadioOption>
            </div>
            <FilterSearchBar>
              <Input
                type='text'
                placeholder='Filter Results'
                aria-label='Filter Results'
                value={searchInput}
                inverted
                onChange={handleInput}
              />
              <BoxButton onPress={clearSearch}>Clear</BoxButton>
            </FilterSearchBar>
          </FilterModalHeader>
          <FilterModalOptions>
            {manuFilteredList
              .filter((manu) => props.facets[manu.trim()] > 0)
              .sort(
                sortAlpha
                  ? (a, b) => {
                    return a.localeCompare(b);
                  }
                  : (a, b) => {
                    return props.facets[b] - props.facets[a];
                  }
              )
              .slice()
              .map((manu) => {
                const manufacturer = props.manuMappings.filter(
                  (mapping) => mapping.value.trim() === manu.trim()
                )[0];
                if(!manufacturer) {
                  return null;
                }
                const count = props.facets[manufacturer.value.trim()] || '0' || 1;
                if(count > 0) {
                  return (
                    <div key={manufacturer.value}>
                      <InvertedRadioOption
                        name='manu_modal'
                        checked={props.manu === manufacturer.value}
                        value={manufacturer.value}
                        onChange={() => {
                          props.changeFilter(manufacturer.slug, 'manu');
                          closeModal();
                        }}
                      >
                        {manufacturer.name} ({count})
                      </InvertedRadioOption>
                    </div>
                  );
                }
              })}
          </FilterModalOptions>
        </ModalContentArea>
      </Modal>
    </OverlayContainer>
  );
};
